module.exports = __webpack_public_path__ + "img/hr-sand-decal-26.2d8c8cd6.png";